import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/home.css';
import Social from './Social';
import Data from './Data';
import Portfolio from './Portfolio';
import profileImg from '../../assets/images/profile.png';
import Kotlin from '../../assets/images/kotlinn.png';
import { Tooltip } from 'react-tooltip';
import partner1 from '../../assets/images/MYTAS1.png';
import partner2 from '../../assets/images/3BIT.png';
import partner3 from '../../assets/images/LD.png';
import partner4 from '../../assets/images/salona-logo.png';
import partner5 from '../../assets/images/DOIT.png';
import ProcessDiagram from './ProcessDiagram';
import IntegrationCircle from './IntegrationCircle';
import { IoLogoAppleAppstore } from 'react-icons/io5';
import PageHeader from '../Layout/PageHeader';

const Home = () => {
  return (
    <>
      <section className="home section" id="home">
        <div className="home__container container">
          <div className="home__content">
            <div>
              <Social />
            </div>
            <div className="home__text">
              <Data />
            </div>
            <img
              src={profileImg}
              alt="NeoApps digital solutions illustration"
              className="home__img"
            />
          </div>
        </div>
      </section>

      <Portfolio embedded />

      <section className="home-section" id="tech-and-partners">
        <div className="page__inner">
          <PageHeader
            label="Technologies"
            title="Our tech stack"
            description="We work with modern tools and frameworks to build scalable, maintainable products."
          />
          <div className="tech__content">
            <div className="tech-pill" data-tooltip-id="react" data-tooltip-content="React">
              <div className="tech-pill__icon">
                <i className="ri-reactjs-line" style={{ color: '#61dafb' }}></i>
              </div>
              <p>React</p>
            </div>
            <div className="tech-pill" data-tooltip-id="angular" data-tooltip-content="Angular">
              <div className="tech-pill__icon">
                <i className="ri-angularjs-fill" style={{ color: '#dd0031' }}></i>
              </div>
              <p>Angular</p>
            </div>
            <div className="tech-pill" data-tooltip-id="vue" data-tooltip-content="Vue.js">
              <div className="tech-pill__icon">
                <i className="ri-vuejs-fill" style={{ color: '#41b883' }}></i>
              </div>
              <p>Vue.js</p>
            </div>
            <div className="tech-pill" data-tooltip-id="node" data-tooltip-content="Node.js">
              <div className="tech-pill__icon">
                <i className="ri-nodejs-fill" style={{ color: '#68a063' }}></i>
              </div>
              <p>Node.js</p>
            </div>
            <div className="tech-pill" data-tooltip-id="java" data-tooltip-content="Java">
              <div className="tech-pill__icon">
                <i className="ri-java-line" style={{ color: '#db8713' }}></i>
              </div>
              <p>Java</p>
            </div>
            <div className="tech-pill" data-tooltip-id="kotlin" data-tooltip-content="Kotlin">
              <div className="tech-pill__icon">
                <img src={Kotlin} alt="" />
              </div>
              <p>Kotlin</p>
            </div>
            <div className="tech-pill" data-tooltip-id="ios" data-tooltip-content="iOS">
              <div className="tech-pill__icon">
                <IoLogoAppleAppstore />
              </div>
              <p>iOS</p>
            </div>
          </div>
          <Tooltip id="react" />
          <Tooltip id="angular" />
          <Tooltip id="vue" />
          <Tooltip id="node" />
          <Tooltip id="java" />
          <Tooltip id="kotlin" />
          <Tooltip id="ios" />
        </div>
      </section>

      <section className="home-section">
        <div className="page__inner">
          <PageHeader
            label="Partners"
            title="Trusted collaborations"
            description="We work with industry-leading partners who share our commitment to quality."
          />
          <div className="partners__content">
            <a href="https://www.mytas.rs" target="_blank" rel="noopener noreferrer" className="partner partner--dark">
              <img src={partner1} alt="Mytas" className="partner__img partner__img--mytas" />
            </a>
            <a href="https://3bit.mt" target="_blank" rel="noopener noreferrer" className="partner partner--3bit">
              <img src={partner2} alt="3BIT" className="partner__img partner__img--3bit" />
            </a>
            <a href="https://lembergdigital.com/index" target="_blank" rel="noopener noreferrer" className="partner partner--dark">
              <img src={partner3} alt="Lemberg Digital" className="partner__img partner__img--ld" />
            </a>
            <a href="https://www.salona.rs" target="_blank" rel="noopener noreferrer" className="partner partner--light">
              <img src={partner4} alt="Salona" className="partner__img partner__img--salona" />
            </a>
            <a href="https://doit-it.services" target="_blank" rel="noopener noreferrer" className="partner partner--light">
              <img src={partner5} alt="DOIT" className="partner__img partner__img--doit" />
            </a>
          </div>
        </div>
      </section>

      <section className="home-section">
        <div className="page__inner">
          <PageHeader
            label="Process"
            title="How we work"
            description="A structured approach from discovery to launch and beyond."
          />
          <ProcessDiagram />
        </div>
      </section>

      <section className="home-section">
        <div className="page__inner">
          <div className="cta-panel">
            <h2 className="cta-panel__title">Save time with NeoApps services</h2>
            <p className="cta-panel__text">
              Tailored web and mobile solutions designed to boost efficiency and deliver real business results.
            </p>
            <Link to="/services" className="button">Explore services</Link>
          </div>
        </div>
      </section>

      <section className="home-section">
        <div className="page__inner">
          <PageHeader
            label="Communication"
            title="Stay connected"
            description="We prioritize clear, effortless collaboration at every step of the project."
          />
          <div className="comm-hub-wrap surface-card">
            <IntegrationCircle />
          </div>
        </div>
      </section>

      <section className="home-section home-section--last">
        <div className="page__inner">
          <div className="cta-panel cta-panel--accent">
            <h2 className="cta-panel__title">Ready to start?</h2>
            <p className="cta-panel__text">Have a project in mind? Let's talk about how we can help.</p>
            <Link to="/contact" className="button">Contact us</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
